__turbopack_context__.v({
  "closeBtn": "variants-module-scss-module__uaT59a__closeBtn",
  "disabled": "variants-module-scss-module__uaT59a__disabled",
  "title": "variants-module-scss-module__uaT59a__title",
  "variant": "variants-module-scss-module__uaT59a__variant",
  "variants": "variants-module-scss-module__uaT59a__variants",
  "variantsWindow": "variants-module-scss-module__uaT59a__variantsWindow",
});
